(() => {
  if (!window.customElements || customElements.get('sc-shipping-progress')) return;
  customElements.define('sc-shipping-progress', class extends HTMLElement {
    connectedCallback() { queueMicrotask(() => { if (this.isConnected) this.render(); }); }
    render() {
      const base = Number(this.dataset.thresholdAud);
      const total = Number(this.dataset.total);
      const currency = this.dataset.currency;
      const rate = currency === 'AUD' ? 1 : Number(window.Shopify?.currency?.rate);
      if (!(base > 0) || !Number.isFinite(total) || !(rate > 0) ||
          (currency !== 'AUD' && window.Shopify?.currency?.active !== currency)) return;
      const threshold = Math.round(base * rate);
      if (!(threshold > 0)) return;
      this.dataset.threshold = String(threshold);
      const remaining = Math.max(0, threshold - total);
      const progress = Math.min(100, Math.max(0, total / threshold * 100));
      const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en',
        { style: 'currency', currency, currencyDisplay: 'narrowSymbol' }).format(cents / 100) + ' ' + currency;
      const message = this.querySelector('.sc-shipping-progress__message');
      const track = this.querySelector('[role="progressbar"]');
      if (!message || !track) return;
      const strong = document.createElement('strong');
      if (remaining) {
        strong.textContent = money(remaining);
        const shipping = document.createElement('strong'); shipping.textContent = 'FREE shipping';
        message.replaceChildren(strong, document.createTextNode(' away from unlocking '), shipping);
      } else {
        strong.textContent = 'FREE shipping';
        message.replaceChildren(strong, document.createTextNode(' unlocked'));
      }
      track.hidden = false;
      track.setAttribute('aria-valuenow', String(Math.round(progress)));
      track.setAttribute('aria-valuetext', money(total) + ' of ' + money(threshold));
      track.firstElementChild.style.width = progress + '%';
    }
  });
})();